import { render } from "./headerComponent.vue?vue&type=template&id=2ed0dc25"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__